/**
 * Created by Rumyantsev Daniil on 12.02.2018.
 */

import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal-window.component.html',
  styleUrls: ['./modal-window.component.css']
})
export class ModalWindowComponent {

  @Input() isSuccess;
  @Input() isScrollable = false;
  visible = false;
  visibleAnimate = false;

  constructor(){}

  public show(): void {
    this.visible = true;
    setTimeout(() => this.visibleAnimate = true, 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/shared-module/modal-window/modal-window.component.ts